import ModuleForm from "./ModuleForm";

function GenericForm(props) {
    const {
        dataRef,
        title,
        formOpen,
        onClose,
        columnList,
        selectedData,
        validationSchema,
        uploadImage,
        previewComplements,
        previewProps,
        onSubmitForm,
        childrenPos,
        children } = props;

    return (
        <div>
            <ModuleForm
                dataRef={dataRef}
                isOpen={formOpen}
                onClose={onClose}
                fieldList={columnList}
                onSubmitForm={onSubmitForm}
                headline={title}
                selectedData={selectedData}
                validationSchema={validationSchema}
                prefix={title}
                uploadImage={uploadImage}
                previewComplements={previewComplements}
                previewProps={previewProps}
                childrenPos={childrenPos}
            >
                {
                    childrenPos && ['endForm', 'startForm'].includes(childrenPos) && (children)
                }
            </ModuleForm>
        </div>

    );
}

export default GenericForm;